module.exports = __webpack_public_path__ + "img/2025-0212-0101.abad7121.png";